module.exports = __webpack_public_path__ + "img/lose.d61ae478.png";